import { ClientProjectDraft } from '@edgebox/api-rest-client';
import { StaticReference } from '@edgebox/data-definition-kit';
import { ButtonLink, Right } from '@edgebox/react-components';
import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { ProjectStatus, SiteApplicationType, SiteEnvironmentType } from '@edgebox/sync-core-data-definitions';
import { ApiComponent, IApiComponentState, ProjectForm } from '../../../common';
import { HeadlineWithBreadcrumbNavigation } from '../../../common/components/BreadcrumbNavigation';
import { IAppContextProp, withAppContext } from '../../../common/contexts/AppContext';
import { INavigateProp, withNavigate } from '../../RouterHelper';
import { ContentBox } from '../../Shared/ContentBox';

interface IState extends IApiComponentState {
  projectDraft?: ClientProjectDraft;
  hasContracts?: boolean;
}

interface IProps extends React.JSX.IntrinsicAttributes, IAppContextProp, INavigateProp {}

class ProjectAddComponent extends ApiComponent<IProps, IState> {
  async load() {
    const customer = this.props.appContext.customer ?? (await this.getCurrentCustomer(true));
    const contracts = await this.api.billing.contracts.search(undefined, { itemsPerPage: 1 }, customer.id);

    if (!contracts.items.length) {
      return {
        hasContracts: false,
      };
    }

    return {
      hasContracts: true,
      projectDraft: new ClientProjectDraft({
        customer: new StaticReference(customer),
        contract: new StaticReference(contracts.items[0]),
        name: 'Dev',
        type: SiteEnvironmentType.Testing,
        status: ProjectStatus.Active,
        appType: SiteApplicationType.Drupal,
      }),
    };
  }

  render() {
    const { projectDraft, hasContracts } = this.state;

    if (hasContracts === undefined) {
      return this.renderRequest();
    }

    if (!hasContracts) {
      return (
        <>
          <HeadlineWithBreadcrumbNavigation className="ms-2">Add Project</HeadlineWithBreadcrumbNavigation>

          <ContentBox className="p-4">
            <Alert variant="warning">An active subscription is required before you can create a project.</Alert>
            <Right>
              <Button variant="light" onClick={() => this.props.navigate('/projects')}>
                Cancel
              </Button>
              <ButtonLink variant="primary" to="/subscriptions">
                Manage subscriptions
              </ButtonLink>
            </Right>
          </ContentBox>
        </>
      );
    }

    if (!projectDraft) {
      return this.renderRequest();
    }

    return (
      <>
        <HeadlineWithBreadcrumbNavigation className="ms-2">Add Project</HeadlineWithBreadcrumbNavigation>

        <ContentBox className="p-4">
          <ProjectForm
            onSave={async (draft) => {
              const project = await this.api.syndication.projects.create(draft as ClientProjectDraft);
              await this.props.appContext.setProject?.(project, undefined, undefined, true);
              this.props.navigate(`/projects/${project.id}/onboarding`);
            }}
            entity={projectDraft}
            mode={'create'}
          >
            <Right>
              <Button variant="light" onClick={() => this.props.navigate('/projects')}>
                Cancel
              </Button>
              <Button type={'submit'} variant={'primary'}>
                Create
              </Button>
            </Right>
          </ProjectForm>
        </ContentBox>
      </>
    );
  }
}

export const ProjectAdd = withNavigate<{}>(withAppContext(ProjectAddComponent));
